module.exports = __webpack_public_path__ + "static/img/index-sys2.fa3e095.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appimg/index/pic/index-sys2.svg
// module id = rK1F
// module chunks = 11